import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomOrderEntry, CustomOrderEntryWithDelivery } from '@cart/const';
import { CustomOrder } from '@order/const';
import { TrackingPickupSchemeComponent } from '@sdvor/tracking/ui';
import { ScrollToService } from '@shared/v2';
import { OrderEntry } from '@spartacus/core';
import { ModalService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ORDER_STATUS } from '../../../components';
import { OrderDetailsComponentService } from '../order-details.component-service';

@Component({
  selector: 'sd-order-details-shipping',
  templateUrl: './order-detail-shipping.component.html',
  styleUrls: ['./order-detail-shipping.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdCustomOrderDetailShippingComponent implements OnInit {
  order$: Observable<CustomOrder>;
  orderEntries$: Observable<CustomOrderEntryWithDelivery[]>;
  showDividedDelivery$: Observable<boolean>;
  public orderStatus = ORDER_STATUS;

  constructor(
    private modalService: ModalService,
    private orderDetailsComponentService: OrderDetailsComponentService,
    private scrollToService: ScrollToService,
  ) {}

  ngOnInit(): void {
    this.showDividedDelivery$ = this.orderDetailsComponentService.getShowDeliverySwitch();

    this.order$ = this.orderDetailsComponentService.getOrderDetails();
    this.orderEntries$ = this.orderDetailsComponentService.orderEntries$.pipe(
      filter(Boolean),
      map((entries) => {
        // Выводим все типы доставок, но отсортированные - сначала доставки, потом самовывоз

        return entries.sort((a, b) => {
          if (a.delivery && b.pickup) {
            return -1;
          } else return 1;
        });
      }),
      map((entries) => {
        return this.orderDetailsComponentService.mapOrderEntriesToGroups(entries);
      }),
      map((entries) => {
        return entries.filter((entry) => entry.deliveryType?.pickup?.address || entry.deliveryType?.delivery?.address);
      }),
    );
  }

  switchDeliveryFilter(deliveryType: string, anchor: string): void {
    this.orderDetailsComponentService.setDeliveryFilter(deliveryType === 'delivery' ? true : false);

    setTimeout(() => this.scrollToAnchor(anchor), 100);
  }

  scrollToAnchor(target?: string): void {
    if (!target) {
      return;
    }

    this.scrollToService.scrollToId(target, { offset: -20 });
  }

  openScheme(scheme: string, orderEntries: CustomOrderEntry[] | OrderEntry[]): void {
    const modalRef = this.modalService.open(TrackingPickupSchemeComponent, {
      centered: true,
      size: 'xl',
      windowClass: 'pickup-tracking-scheme',
    });

    modalRef.componentInstance.scheme = scheme;
    modalRef.componentInstance.orderEntries = orderEntries;
  }
}
